// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SignatureDocumentUpload {
    static getAttributeTypeMap() {
        return SignatureDocumentUpload.attributeTypeMap;
    }
}
SignatureDocumentUpload.discriminator = undefined;
SignatureDocumentUpload.additionalProperties = false;
SignatureDocumentUpload.attributeTypeMap = [
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": ""
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "string"
    },
    {
        "name": "documentData",
        "baseName": "documentData",
        "type": "string"
    },
];
//# sourceMappingURL=signatureDocumentUpload.js.map